/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

import axios from "axios";
import { wrapper } from "axios-cookiejar-support";
import { CookieJar } from "tough-cookie";
const jar = new CookieJar();
const env = process.env.NODE_ENV || "development";
// import { useLocation } from 'react-router-dom'

const baseURL =
  env === "production"
    ? "https://admin.lenektech.com/api"
    : "http://127.0.0.1:8080";
axios.defaults.baseURL = baseURL;

// Create Axios instance
const instance = wrapper(axios.create({ jar }));
function parseJwtFromCookie() {
  const jwtToken = localStorage.getItem("token");
  return jwtToken;
}

// Add a request interceptor
instance.interceptors.request.use(
  (config) => {
    const jwtToken = parseJwtFromCookie();
    if (jwtToken) {
      config.headers.Authorization = `Bearer ${jwtToken}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

function deleteAllCookies() {
  const cookies = document.cookie.split("; ");
  for (let c of cookies) {
    const eqPos = c.indexOf("=");
    const name = eqPos > -1 ? c.substr(0, eqPos) : c;
    document.cookie = name + "=; Max-Age=0; path=/;";
  }
}

const logoutUser = async () => {
  try {
    localStorage.removeItem("username");
    localStorage.removeItem("admin");
    const res = await makeRequest("POST", "/auth/logout", {});
    window.location.href = "/";
  } catch (err) {
    console.log(err);
  }
};

// Modified Function to make a request with Axios, adding onUploadProgress
export async function makeRequest(
  method,
  url,
  data,
  options = {},
  onUploadProgress = null,
) {
  try {
    // Check if onUploadProgress is provided and is a function, then include it in the options
    if (typeof onUploadProgress === "function") {
      options.onUploadProgress = onUploadProgress;
    }

    // console.log(`Request initiated method: ${method} on url ${url}`)
    const response = await instance({
      method,
      url,
      data,
      ...options,
      withCredentials: true,
    });

    return response;
  } catch (error) {

    if (!error.response) {
      console.error("Network / Axios error:", error.message);
      throw error;
    }

    const { config, data, status } = error.response;

    console.log(config?.url);
    console.log(data?.statusCode);
    console.log(data?.message);

    if (data) {
      return data;
    }

    if (
      config?.url === "/auth/alive" &&
      data?.statusCode === 400 &&
      data?.message === "Custom Guard"
    ) {
      deleteAllCookies();
      console.log("User is not logged in");
    }

    else if (
      data?.statusCode === 400 &&
      data?.message === "Custom Guard"
    ) {
      deleteAllCookies();
      logoutUser();
    }

    else if (
      config?.url !== "/auth/alive" &&
      data?.statusCode === 401 &&
      data?.message === "Custom Guard"
    ) {
      deleteAllCookies();
      logoutUser();
    }

    throw error;
  }
}
export default instance;
